import { deserializeXY } from "../serialization";
import { Fence } from "./fence";

export class FenceLight extends Fence {
	static key = "FenceLight";

	static deserialize(data: any): FenceLight {
		const f = new FenceLight(deserializeXY(data.xy));
		f.restoreBaseFields(data);
		return f;
	}
}
